module.exports = __webpack_public_path__ + "img/alert.4f3e5262.svg";